'use strict';

class Timer {
  constructor(loggerParam) {
    this.loggerParam = loggerParam;
    this.start();
  }

  start() {
    this.startTime = new Date();
  }

  complete(eventCount = null) {
    if (!(this.startTime instanceof Date)) {
      return null;
    }

    const endTime = new Date();
    const timeDiff = endTime - this.startTime;

    const message = {
      name: this.loggerParam,
      data: {
        elapsedTime: `${timeDiff} ms`,
      },
    };

    if (eventCount != null) {
      message.data['eventCount'] = eventCount;
    }
    return message;
  }
}

module.exports = Timer;
